// extracted by mini-css-extract-plugin
export default {"total_score":"DashboardStatistc_total_score__PzmgE","top_side":"DashboardStatistc_top_side__CDPvk","total_price":"DashboardStatistc_total_price__1KbDM"};